var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor", staticStyle: { "min-width": "700px" } },
    [
      _c("div", { ref: "toolbar", staticClass: "toolbar" }),
      _c("div", { ref: "editor", staticClass: "wtext" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }